import { UPDATE_SCREEN_SIZE } from '../constants';

export default (state = 0, action) => {
  switch (action.type) {
    case UPDATE_SCREEN_SIZE:
      return action.screenSize;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/screenSize.js